import EmptyImageCrossIcon from "./EmptyImageCrossIcon";
export default EmptyImageCrossIcon;
